import { B2B_ACCOUNT_PROFILE_PATH } from '../../constants/links';
import { apiB2B } from '../axios-client';
export const b2bAccountApi = {
    profileDetails: () => {
        return apiB2B.get(B2B_ACCOUNT_PROFILE_PATH);
    },
};
